export default {
	name: 'queryMoney',
	data() {
		return {
			searchText: '-1',
			beginData: '',
			endTime: '',
			clear: {},
			pageIndex: 1,
			pageRows: 10,
			count: 0,
			getData: {},
			payRecord: [],
			sum: [],
			action: ['会员办理', '会员退费', '押金缴费', '押金退费', '阅读费用', '配送费用', '异常还书',
				'书籍售出', '书箱收费', '书箱退费','体验课收费','体验课退费'
			],
			Deposit: 0,
			ShopID: this.$store.state.user.ShopID,
			areaID: this.$store.state.user.areaID,
			Shop: this.$store.state.shop.filter(x => x.areaID == this.areaID)
		}
	},
	created() {
		this.areaID = this.$store.state.user.areaID;
		this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
		this.getData = () => {
			this.$request.request({
				url: 'Query/queryMoney',
				data: {
					pageIndex: this.pageIndex,
					pageCount: this.pageRows,
					beginData: this.beginData,
					endTime: this.endTime,
					searchText: this.searchText,
					ShopID: this.ShopID
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					console.log(this.payRecord)
					this.sum = r.sum;
					this.payRecord = r.payRecord;
					this.Deposit = r.Deposit;
					this.count = r.sum.count;
				} else {
					this.$uil.showMessage({
						text: r.message
					});
				}
			})
		}


	},

	methods: {
		selectArea() {
			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
			this.count = 0;
			if (this.Shop.length > 0) {
				this.ShopID = this.Shop[0].ShopID;
				this.pageIndex = 1;
				this.getData();
			}
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}

			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		checkbook() {
			return this.BooksName.length > 0 && this.BookBriefIntroduction.length > 0 && this.WriterName.length > 0 &&
				this.ClassificationID >
				0 && this.RecommendReason.length > 0 && this.BookRecommend.length > 0 && this.Tag.length > 0;
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		}
	},
	filters: {
		rmb(v) {
			return "￥" + (v == null ? "0" : v) + '元';
		}

	},
	activated() {
		this.getData();
	}

}
